import {
  EndorsementStatus,
  EndorsementUnderwritingDecision,
} from "@covertree/agent-portal-graphql";

import type { EndorsementData } from "./types";

const FAILED_DECISIONS: (EndorsementUnderwritingDecision | undefined)[] = [
  EndorsementUnderwritingDecision.Referred,
  EndorsementUnderwritingDecision.Declined,
];

export const isUnderwritingFailed = (
  endorsement?: Pick<EndorsementData, "underwritingDecision" | "status"> | null
) =>
  FAILED_DECISIONS.includes(endorsement?.underwritingDecision) ||
  endorsement?.status === EndorsementStatus.AwaitingApproval;

export const needsUnderwritingReview = (
  endorsement?: Pick<
    EndorsementData,
    "underwritingDecision" | "status" | "underwritingNotes"
  > | null
) =>
  isUnderwritingFailed(endorsement) || !!endorsement?.underwritingNotes?.length;
